"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuperAdminWarning = void 0;
const react_1 = __importStar(require("react"));
const polaris_1 = require("@shopify/polaris");
const styled_components_1 = __importDefault(require("styled-components"));
const context_1 = require("@/common/context");
const StyledBanner = styled_components_1.default.div `
  padding: 15px 25px 0;
`;
const SuperAdminWarning = () => {
    const [showWarningBanner, setShowWarningBanner] = (0, react_1.useState)(false);
    const { currentUser } = (0, context_1.useCurrentUser)();
    const toggleWarningBanner = (0, react_1.useCallback)(() => {
        setShowWarningBanner((prev) => !prev);
    }, []);
    (0, react_1.useEffect)(() => {
        if (currentUser === null || currentUser === void 0 ? void 0 : currentUser.admin) {
            setShowWarningBanner(true);
        }
    }, [currentUser]);
    if (!showWarningBanner) {
        return null;
    }
    return (react_1.default.createElement(StyledBanner, null,
        react_1.default.createElement(polaris_1.Banner, { onDismiss: () => toggleWarningBanner(), title: 'SUPER ADMIN MODE - PLEASE USE CAUTION!', tone: 'critical' })));
};
exports.SuperAdminWarning = SuperAdminWarning;
